import { Component } from '@angular/core';
import { Hero } from '../../components/hero/hero';
import { Services } from '../../components/services/services';
import { Projects } from '../../components/projects/projects';
import { About } from '../../components/about/about';
import { Contact } from '../../components/contact/contact';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [Hero, Services, Projects, About, Contact],
  templateUrl: './home.html',
})
export class Home {}
